import React from "react";
import Navbar from "@/components/Navbar";
import { AthleteDashboardContent } from "@/components/athlete/AthleteDashboardContent";

const DashboardPage = () => {
  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      {/* pt-24 mobile (navbar only) → pt-32 desktop (navbar + pill row).
          pb-24 mobile leaves room above the bottom tab bar. */}
      <div className="pt-24 sm:pt-32 pb-24 sm:pb-12 px-6">
        <AthleteDashboardContent />
      </div>
    </div>
  );
};

export default DashboardPage;
